export default class UserMetaExternalAmsData {

	public id: string | null = null;
	public name: string| null = null;

	public constructor() {

	}
};